import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  Gutter,
  ParagraphHeader,
  ReadonlyTextarea,
  SmallHeader,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type OnboardingWorkScheduleProps = {
  name: string;
  scheduleText: Nullable<
    Pick<
      NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
      'weeklyCommitment' | 'overtime'
    >
  >;
};

export const OnboardingWorkSchedule = ({
  name,
  scheduleText,
}: OnboardingWorkScheduleProps) => {
  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>Work Schedule</SmallHeader>
      </CardHeader>
      <CardSection>
        {scheduleText.weeklyCommitment ? (
          <ReadonlyTextarea
            name="commitment"
            value={scheduleText.weeklyCommitment}
            formatting="modern"
          />
        ) : null}
        {scheduleText.overtime ? (
          <>
            <ParagraphHeader>Overtime:</ParagraphHeader>
            <Gutter bottom="8px" />
            <ReadonlyTextarea
              name="overtime"
              value={scheduleText.overtime}
              formatting="modern"
            />
          </>
        ) : null}
      </CardSection>
    </Card>
  );
};
